import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, toJS} from '@api'
import {PrimaryIconButton} from 'centric-ui-components'
import {PageNavigationChevronButtons, usePresentationModeContentStore} from './'
import {PresentationModeContentStore, useVipLocalStore, utils, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import * as css from './CurrentPageView.css'
import {PresentationPageView, PresentationPageGroupContent, PresentationPageTitle} from './pageContents'

/// region Store

export class CurrentPageViewStore extends VipLocalStore {

  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'> & { store: PresentationModeContentStore }) {
    super(stores)
  }

  get store() { return this.props.store}

  get page() { return this.store.page}

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }
}

export const CurrentPageViewStoreContext = React.createContext<CurrentPageViewStore>(null)
export const useCurrentPageViewStore = () => React.useContext(CurrentPageViewStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const CurrentPageView = observer<MyProps>(function CurrentPageView({className, ...props}) {
  const presentationStore = usePresentationModeContentStore(),
    obsProps = useAsObservableSource({...props, store: presentationStore}),
    store = useVipLocalStore((stores) => new CurrentPageViewStore(stores, obsProps))

  useEffect(() => store.registerEffects(), [])

  const {page, store: {pageNumber, settings: {showScrollbars}}} = store
  return (
    <CurrentPageViewStoreContext.Provider value={store}>
      <div className={css.root}
           data-hide-scrollbars={showScrollbars !== true}
           // onClick={toggleShow}
      >
        <PresentationPageView page={page} key={pageNumber} />
        <PageNavigationChevronButtons/>
      </div>
    </CurrentPageViewStoreContext.Provider>)
})



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/PresentationMode/CurrentPageView.tsx